import React from 'react';
import { Github, ExternalLink } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200 mt-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-3">About</h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              Think Robin analyzes market demand using travel, accommodation, 
              and interest signals to provide accurate demand forecasting for any location.
            </p>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-3">Features</h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li>• Real-time demand scoring (0-100)</li>
              <li>• Multi-signal analysis</li>
              <li>• 90-day forecasting</li>
              <li>• Global location support</li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-3">Data Sources</h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li className="flex items-center">
                <ExternalLink className="w-3 h-3 mr-2" />
                SerpApi Google Flights
              </li>
              <li className="flex items-center">
                <ExternalLink className="w-3 h-3 mr-2" />
                SerpApi Google Search
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-gray-200 flex items-center justify-between">
          <p className="text-xs text-gray-500">
            © 2025 Think Robin. Built with FastAPI and React.
          </p>
          
          <div className="flex items-center space-x-4">
            <span className="text-xs text-gray-500">v1.0.0</span>
            <div className="flex items-center space-x-1">
              <div className="w-2 h-2 bg-green-500 rounded-full"></div>
              <span className="text-xs text-gray-500">System Operational</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
